exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-dashboard-center {\n  padding: 18px;\n  text-align: center; }\n\n.div-grouplist {\n  padding: 2px;\n  text-align: left; }\n\n.p5 {\n  padding: 5px; }\n\n.div-export {\n  text-align: left;\n  padding-top: 15px;\n  padding-bottom: 1px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/export/dashboardexport/dashboard-export-dialog.component.scss
// module id = ../../../../../src/app/shared/export/dashboardexport/dashboard-export-dialog.component.scss
// module chunks = main